import Plot from './plot';
export default Plot;
